<template>
  <div class="pages">
    <div class="search-box new-input-box">
      <div style="flex: 1; display: flex; align-items: center">
        <div style="display: flex; align-items: center">
          <span>名单标题：</span>
          <el-input
            style="width: 300px"
            v-model="tableParams.title"
            placeholder="请输入"
          ></el-input>
        </div>
        <div style="display: flex; align-items: center; margin-left: 30px">
          <span>创建时间：</span>
          <el-date-picker
            v-model="tableParams.createTime"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <div>
        <el-button class="btn-break" @click="getWinList">查询</el-button>
        <el-button @click="reSetForm" style="width: auto">重置</el-button>
      </div>
    </div>
    <div class="handler-btn">
      <el-button
        @click="
          isImport = true;
          adddialogVisible = true;
        "
        >导入名单</el-button
      >
      <el-button @click="adddialogVisible = true" style="width: auto"
        >添加系统活动名单</el-button
      >
    </div>
    <div class="table-box">
      <el-table
        :data="winList"
        v-loading="winListLoading"
        style="width: 100%"
        :border="true"
      >
        <el-table-column prop="title" label="活动类型" width="150">
          <template #default="{ row }">
            {{
              activityTypeList.find((v) => v.id == row.subType)
                ? activityTypeList.find((v) => v.id == row.subType).label
                : "--"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="名单标题" width="300">
        </el-table-column>
        <el-table-column prop="title" label="人数" width="150">
          <template #default="{ row }">
            <el-button class="btn-text" @click="showRecordPage(row)">{{
              row.memberCount || 0
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="名单来源" width="200">
          <template #default="{ row }">
            {{ row.source == 0 ? "系统名单" : "导入名单" }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="" width="200">
          <template #header>
            <div class="flexc-cen-x" style="height: 40px">
              <span>是否在列表显示</span>
              <el-tooltip
                effect="light"
                content="默认不显示，点击开关开启后显示到中奖名单列表页"
                placement="bottom"
              >
                <i
                  class="el-icon-question"
                  style="color: #ccc; margin-left: 4px"
                ></i>
              </el-tooltip>
            </div>
          </template>
          <template #default="{ row }">
            <el-switch
              :disabled="uptateLoading"
              v-model="row.isShow"
              :active-value="1"
              :inactive-value="0"
              @change="updateItem(row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="priority" label="列表展示优先级" width="180">
          <template #header>
            <div class="flexc-cen-x">
              <span>列表展示优先级</span>
              <el-tooltip
                effect="light"
                content="数字越小优先级越高，展示在越前面，优先级相同时，按创建时间最近优先展示"
                placement="bottom"
              >
                <i
                  class="el-icon-question"
                  style="color: #ccc; margin-left: 4px"
                ></i>
              </el-tooltip>
            </div>
          </template>
          <template #default="{ row }">
            <el-input-number
              :disabled="uptateLoading"
              v-model="row.priority"
              :min="1"
              @change="updateItem(row)"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column label="操作" width="220">
          <template #default="{ row }">
            <el-button class="btn-text" @click="openPromotionDialog(row)"
              >推广</el-button
            >
            <el-button class="btn-text" @click="editItem(row)">{{
              row.source == 0 ? "编辑" : "导入"
            }}</el-button>
            <el-button class="btn-text" @click="delWinItem(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        class="new-pagination-page"
        style="margin: 18px 0; display: flex; justify-content: flex-end"
      >
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="Number(listTotal)"
          :page-size.sync="pageSize"
          :current-page.sync="current"
          @size-change="getWinList"
          @current-change="getWinList"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="isImport ? '导入名单' : '添加名单'"
      :visible.sync="adddialogVisible"
      @closed="closeAddDialog"
      width="50%"
    >
      <div class="new-input-box" v-if="adddialogVisible">
        <el-form
          ref="form"
          :model="addForm"
          :rules="addFormRules"
          label-width="120px"
        >
          <el-form-item label="名单标题" prop="title">
            <el-input
              v-model="addForm.title"
              show-word-limit
              placeholder="请输入"
              maxlength="15"
            ></el-input>
          </el-form-item>
          <el-form-item label="显示字段" prop="displayFields" v-if="!isImport">
            <el-checkbox-group v-model="addForm.displayFields">
              <el-checkbox label="用户名称" disabled>用户名称</el-checkbox>
              <el-checkbox label="订单号">订单号</el-checkbox>
              <el-checkbox label="奖品名称">奖品名称</el-checkbox>
              <el-checkbox label="中奖时间">中奖时间</el-checkbox>
              <el-checkbox label="用户PIN">用户PIN</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="选择活动" prop="activityId" v-if="!isImport">
            <div>
              <div style="display: flex; align-items: center">
                <el-select
                  v-model="addForm.subType"
                  placeholder="活动类型"
                  @change="
                    addForm.activityId = '';
                    getActivityList();
                  "
                >
                  <el-option
                    v-for="item in activityTypeList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-select
                  style="margin-left: 10px"
                  :disabled="!addForm.subType"
                  v-model="addForm.activityId"
                  filterable
                  remote
                  reserve-keyword
                  :remote-method="getActivityList"
                  v-loading="activityListLoading"
                  placeholder="请选择活动"
                >
                  <el-option
                    v-for="item in activityList"
                    :key="item.id"
                    :label="item.activityName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="上传名单" v-if="isImport">
            <div>
              <div style="display: flex; align-items: center">
                <el-upload
                  accept=".xlsx"
                  :action="improtAction"
                  ref="upload"
                  :file-list="importFileList"
                  :on-change="handleSuccess"
                  :on-remove="removeFile"
                  :auto-upload="false"
                  :show-file-list="true"
                  :limit="100"
                >
                  <el-button class="btn-blue">上传文件</el-button>
                </el-upload>
                <el-button
                  class="btn-text"
                  style="margin-left: 8px"
                  @click="openExe"
                  >下载模板</el-button
                >
              </div>
              <div style="margin-top: 16px">
                <jd-tip>
                  <p>1.仅支持扩展名：xlsx，文件大小不超过2M</p>
                  <p>2.文件最多支持1000条数据</p>
                </jd-tip>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="中奖数据" v-if="!isImport">
            <el-radio-group v-model="addForm.winningData">
              <el-radio :label="0">仅显示已发放奖品名单</el-radio>
              <el-radio :label="1">显示所有奖品名单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="查看活动" v-if="!isImport">
            <el-radio-group v-model="addForm.isShowActivity">
              <el-radio :label="0">不支持前往活动详情页查看活动</el-radio>
              <el-radio :label="1">支持前往活动详情页</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="adddialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addWinList">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="活动推广"
      :visible.sync="promotionDialogVisible"
      @close="qrcodeVue.value = ''"
      width="30%"
    >
      <div style="color: #999; text-align: center">
        请用手机京东扫描下面二维码查看您店铺的活动详情
      </div>
      <div style="margin-top: 16px">
        <qrcode-vue
          v-if="qrcodeVue.value"
          class="qrcode"
          :id="'qrcode'"
          :ref="'qrcode'"
          :size="qrcodeVue.size"
          :value="qrcodeVue.value"
          :bgColor="qrcodeVue.bgColor"
          :fgColor="qrcodeVue.fgColor"
          style="text-align: center"
        >
        </qrcode-vue>
      </div>
      <div class="copy-link">
        <el-tooltip
          class="item"
          effect="dark"
          :content="qrcodeVue.value"
          placement="top-start"
        >
          <div class="line-text">自定义页面链接：{{ qrcodeVue.value }}</div>
        </el-tooltip>
        <el-button
          type="blueText"
          style="margin-left: 12px"
          v-clipboard:copy="qrcodeVue.value"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >复制</el-button
        >
        <el-button
          type="blueText"
          style="margin-left: 12px"
          @click="handleSrcImg"
          >下载</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="中奖名单"
      :visible.sync="winListDialogVisible"
      @open="getwinnerListRecord(-1)"
      width="50%"
    >
      <el-table
        :data="winListRecord"
        v-loading="winListRecordLoading"
        style="width: 100%"
        height="500"
      >
        <el-table-column prop="memberNick" label="用户名称"> </el-table-column>
        <el-table-column prop="chaosPin" label="用户PIN">
          <template #default="{ row }">
            {{ row.chaosPin || "--" }}
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="订单号">
          <template #default="{ row }">
            {{ row.orderNo || "--" }}
          </template>
        </el-table-column>
        <el-table-column prop="prizeName" label="奖品名称">
          <template #default="{ row }">
            {{ row.prizeName || "--" }}
          </template>
        </el-table-column>
        <el-table-column prop="winTime" label="中奖时间">
          <template #default="{ row }">
            {{ row.winTime || "--" }}
          </template>
        </el-table-column>
      </el-table>
      <div
        class="new-pagination-page"
        style="margin: 18px 0; display: flex; justify-content: flex-end"
      >
        <el-pagination
          layout="total,sizes, prev, pager, next, jumper"
          background
          :total="Number(winRecordTotal)"
          :page-size.sync="winRecordParams.size"
          :current-page.sync="winRecordParams.current"
          @size-change="getwinnerListRecord"
          @current-change="getwinnerListRecord"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import qrcodeVue from "qrcode-vue";
import {
  winnerListPage,
  winnerListRecord,
  paradiseAndTaskCommonList,
  winnerListSaveOrEdit,
  winnerListImport,
  winnerListDelete,
} from "@/api/winList.js";
export default {
  name: "",
  components: {
    qrcodeVue,
  },
  props: {},
  data() {
    return {
      winListRecord: [],
      winRecordParams: {
        current: 1,
        size: 10,
      },
      winRecordTotal: 0,
      winListRecordLoading: false,
      winListDialogVisible: false,
      qrcodeVue: {
        size: 200,
        bgColor: "#fff",
        fgColor: "#000",
        value: "", //二维码地址
        logo: require("@/assets/thdImg/common/jd_logo.svg"), //logo图片
      },
      currentItem: {},
      promotionDialogVisible: false,
      improtAction: "/jd-hd-web/image/upload",
      importFileList: [],
      isImport: false,
      tableParams: {
        createTime: [],
        title: "",
      },
      pageSize: 10,
      current: 1,
      listTotal: 0,
      winList: [],
      winListLoading: false,
      adddialogVisible: false,
      addForm: {
        activityId: "",
        displayFields: ["用户名称"],
        title: "",
        subType: "",
        winningData: 0,
        isShowActivity: 0,
      },
      addFormRules: {
        title: [{ required: true, message: "请输入名单标题", trigger: "blur" }],
        displayFields: [
          { required: true, message: "请选择显示字段", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value && value.length > 0) {
                callback();
              } else {
                callback(new Error("请至少选择一个显示字段!"));
              }
            },
            trigger: "change",
          },
        ],
        activityId: [
          { required: true, message: "请选择活动", trigger: "change" },
        ],
      },
      activityList: [],
      activityListLoading: false,
      activityTypeList: [
        { label: "签到赢好礼", id: 1, mainTypes: 1 },
        { label: "每日限时抢", id: 3, mainTypes: 1 },
        { label: "关注店铺有礼", id: 4, mainTypes: 1 },
        { label: "完善信息有礼", id: 7, mainTypes: 1 },
        { label: "加购有礼", id: 34, mainTypes: 1 },
        { label: "生日有礼", id: 39, mainTypes: 1 },
        { label: "会员升级礼", id: 44, mainTypes: 1 },
        { label: "开卡礼包", id: 13, mainTypes: 2 },
        { label: "店铺礼包", id: 14, mainTypes: 2 },
        { label: "店铺礼包（千人千面）", id: 15, mainTypes: 2 },
        { label: "预售有礼", id: 27, mainTypes: 2 },
        { label: "预售抽奖", id: 28, mainTypes: 2 },
        { label: "首单专享礼", id: 17, mainTypes: 2 },
        { label: "复购有礼", id: 18, mainTypes: 2 },
        { label: "下单有礼", id: 16, mainTypes: 2 },
        { label: "下单抽奖", id: 19, mainTypes: 2 },
        { label: "下单冲榜", id: 36, mainTypes: 2 },
        { label: "评价有礼", id: 20, mainTypes: 2 },
        { label: "晒单有礼", id: 41, mainTypes: 2 },
        { label: "邀请开卡有礼", id: 5, mainTypes: 3 },
        { label: "邀请关注有礼", id: 6, mainTypes: 3 },
        { label: "裂变神券", id: 21, mainTypes: 3 },
        { label: "超级裂变神券", id: 31, mainTypes: 3 },
        { label: "情书贺卡", id: 50, mainTypes: 3 },
        { label: "幸运抽奖", id: 8, mainTypes: 4 },
        { label: "天降红包雨", id: 22, mainTypes: 5 },
        { label: "欢乐娃娃机", id: 23, mainTypes: 5 },
        { label: "大家来找茬", id: 24, mainTypes: 5 },
        // { label: "兑换优惠券", id: 10, mainTypes: 6 },
        // { label: "兑换实物", id: 9, mainTypes: 6 },
        // { label: "兑换京豆", id: 29, mainTypes: 6 },
        // { label: "兑换E卡", id: 30, mainTypes: 6 },
        // { label: "新人优惠券", id: 11, mainTypes: 7 },
        // { label: "会员券", id: 12, mainTypes: 7 },
      ],
      uptateLoading: false,
    };
  },
  computed: {
    ...mapState(["loginUserInfo"]),
  },
  watch: {
    loginUserInfo: {
      handler: function (v) {
        if (v.venderId) {
          this.getWinList();
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    getwinnerListRecord(e) {
      if (e == -1) {
        this.winRecordParams.current = 1;
        this.winRecordParams.size = 10;
      }
      let data = {
        activityId: this.currentItem.activityId,
        venderId: this.currentItem.venderId,
        source: this.currentItem.source,
        winnerListId: this.currentItem.id,
      };
      data.current = this.winRecordParams.current;
      data.size = this.winRecordParams.size;
      this.winListRecordLoading = true;
      winnerListRecord(data)
        .then((res) => {
          this.winListRecordLoading = false;
          if (res.code == 1) {
            this.winListRecord = res.data.records;
            this.winRecordTotal = res.data.total || 0;
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.winListRecordLoading = false;
        });
    },
    showRecordPage(item) {
      this.currentItem = item;
      this.winListDialogVisible = true;
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleSrcImg() {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "imgQR";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    openPromotionDialog(item) {
      let xcxUrl = this.$commonUrl(); // 正式
      let params1 = `venderId%3D${item.venderId}%26id%3D${item.id}`;
      this.qrcodeVue.value =
        xcxUrl + "pages_2/winList/winList.html%3f" + params1;
      this.currentItem = item;
      this.promotionDialogVisible = true;
    },
    delWinItem(item) {
      this.$confirm(`操作不可逆，确认删除"${item.title}"吗？`, "确认删除").then(
        (res) => {
          winnerListDelete(item.id).then((res) => {
            if (res.code == 1) {
              this.$message.success("删除成功");
              this.getWinList();
            } else {
              this.$message.warning(res.message);
            }
          });
        }
      );
    },
    closeAddDialog(done) {
      console.log("关闭回调");
      this.isImport = false;
      this.importFileList = [];
      this.addForm = {
        activityId: "",
        displayFields: ["用户名称"],
        title: "",
        subType: "",
        winningData: 0,
        isShowActivity: 0,
      };
    },
    // 下载模板文件
    openExe() {
      window.open(
        "https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/template/importTemplate.xlsx",
        "_blank"
      );
    },
    removeFile() {
      this.importFileList = [];
    },
    handleSuccess(file, fileList) {
      console.log(file, fileList);
      const limit = 1024 * 1024 * 2;
      if (file.size > limit) {
        this.$message.warning("文件大小不得超过2M");
        this.importFileList = [];
      } else {
        this.importFileList = [file];
      }
    },
    editItem(item) {
      this.addForm = {
        ...item,
        displayFields: item.tableField ? item.tableField.split(",") : [],
        winningData: item.winningData || 0,
        isShowActivity: item.isShowActivity || 0,
      };
      if (item.source == 0) {
        this.getActivityList("");
      } else {
        this.isImport = true;
      }
      this.adddialogVisible = true;
    },
    updateItem(item) {
      let data = item;
      this.uptateLoading = true;
      data.displayFields = item.tableField ? item.tableField.split(",") : [];
      winnerListSaveOrEdit(data)
        .then((res) => {
          this.uptateLoading = false;
          if (res.code == 1) {
            this.$message.success("保存成功");
          } else {
            this.$message.warning(res.message);
          }
          this.getWinList();
        })
        .catch((err) => {
          console.log(err);
          this.uptateLoading = false;
        });
    },
    reSetForm() {
      this.tableParams.title = "";
      this.tableParams.createTime = [];
      this.current = 1;
      this.pageSize = 10;
      this.getWinList();
    },
    saveSuccess() {
      this.isImport = false;
      this.adddialogVisible = false;
      this.addForm = {
        activityId: "",
        displayFields: [],
        title: "",
        subType: "",
        winningData: 0,
        isShowActivity: 0,
      };
      this.current = 1;
      this.pageSize = 10;
      this.getWinList();
    },
    addWinList() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isImport) {
            if (this.importFileList.length == 0) {
              this.$message.warning("请先选择文件");
            } else {
              console.log(this.importFileList[0]);
              let formData = new FormData();
              formData.append("file", this.importFileList[0].raw);
              console.log("formData:", formData);
              winnerListImport(
                `?title=${this.addForm.title}${
                  this.addForm.id ? "&id=" + this.addForm.id : ""
                }`,
                formData
              ).then((res) => {
                if (res.code == 1) {
                  this.$message.success("导入成功");
                  this.saveSuccess();
                } else {
                  this.$message.warning(res.message);
                }
              });
            }
            return;
          }
          let data = { ...this.addForm };
          winnerListSaveOrEdit(data).then((res) => {
            if (res.code == 1) {
              this.$message.success("添加成功");
              this.saveSuccess();
            } else {
              this.$message.warning(res.message);
            }
          });
        }
      });
    },
    getActivityList(type) {
      // this.addForm.activityId = "";
      this.activityListLoading = true;
      const subType = this.activityTypeList.find(
        (v) => v.id == this.addForm.subType
      );
      let data = {
        size: 99,
        current: 1,
        activityName: this.addForm.subType != type ? type : "",
        activityType: this.addForm.subType,
        status: "",
        activityNewMainTypes: (subType && subType.mainTypes) || 1,
      };
      paradiseAndTaskCommonList(data)
        .then((res) => {
          this.activityListLoading = false;
          if (res.code == 1) {
            this.activityList = res.data.records;
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.activityListLoading = false;
        });
    },
    getWinList() {
      this.winListLoading = true;
      let data = {
        current: this.current,
        size: this.pageSize,
        venderId: this.loginUserInfo.venderId,
      };
      data.title = this.tableParams.title;
      if (this.tableParams.createTime.length == 2) {
        data.startTime = this.tableParams.createTime[0];
        data.endTime = this.tableParams.createTime[1];
      }
      winnerListPage(data)
        .then((res) => {
          this.winListLoading = false;
          if (res.code == 1) {
            this.winList = res.data.records;
            this.listTotal = res.data.total;
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.winListLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-blue {
  width: auto;
  background: rgba(255, 255, 255, 1);
  border: 1px solid #7b61ff;
  color: #7b61ff;
  transition: all 0.2s;

  &:hover {
    background-color: #7b61ff;
    color: #fff;
  }
}
.btn-text {
  width: auto;
  padding: 0 !important;
  // margin: 0 !important;
  border: 0 !important;
  color: #7b61ff;
  &:hover {
    background-color: transparent;
  }
}
.btn-break {
  width: auto;
  background-color: #7b61ff;
  color: white;
  border: 1px solid #7b61ff;
}
.copy-link {
  margin-top: 30px;
  display: flex;
  align-items: center;
}
.line-text {
  max-width: 450px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
.pages {
  height: calc(100vh - 118px);
  background: #fff;
  padding: 0 16px;
  box-sizing: border-box;
  overflow-y: scroll;
}
.search-box {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.handler-btn {
  margin: 16px 0 12px;
  display: flex;
  align-items: center;
}
::v-deep
  .table-box
  .el-table
  .el-table__header-wrapper
  .el-table__header
  .has-gutter
  > tr
  > th {
  height: 40px !important;
  .cell {
    height: 40px !important;
    padding-left: 20px;
    line-height: 40px;
    font-weight: bold;
    font-size: 12px;
    color: #333333;
  }
  background: #f5f6f7;
  border-radius: 0px 0px 0px 0px;
}
</style>
<style lang="less" scoped>
// flex
.flex-cen-xy {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flexc-cen-x {
  display: flex;
  align-items: center;
}

.flexc-cen-y {
  display: flex;
  justify-content: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-y {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.flex-xy {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flex-x {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.flex-spc-x {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-x-start {
  display: flex;
  align-items: start;
}

.flex-dispaly-wrap {
  display: flex;
  flex-wrap: wrap;
}

.flex-left {
  float: left;
}

.flex-right {
  float: right;
}

.white-spacr-no {
  white-space: nowrap;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.flex-father-box {
  display: flex;
  flex-direction: column;
}

.flex-1 {
  flex: 1;
}
</style>
